<template>
  <v-card
    v-show="selectedEvent"
    class="my-0"
    flat
    :loading="loading"
  >
    <v-toolbar
      class="px-3"
      height="45"
      elevation="0"
    >
      <v-btn
        v-if="!$store.state.accessType"
        icon
        @click="editName = !editName"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-text-field
        v-if="editName"
        v-model="selectedEvent.name"
        style="margin-top: -13px"
        solo
        flat
        dense
      />
      <v-chip
        v-if="!editName"
        class="ma-1 ms-0"
        :color="selectedEvent.color"
        label
        small
        text-color="white"
      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        {{ selectedEvent.name }}
      </v-chip>
      <!--      <v-toolbar-title-->
      <!--        v-html="selectedEvent.name"-->
      <!--      />-->
      <v-spacer />
      <div v-if="!hideBarBtnProp && $store.state.admin === 'active' && !$store.state.accessType">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              small
              :disabled="(sessionStatus != null ? true : false)"
              v-on="on"
              @click="$emit('setMoveStatus','move')"
            >
              <v-icon>mdi-transfer</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('move') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              small
              v-on="on"
              @click="$emit('setMoveStatus','copy')"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('copy') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              small
              class="me-1"
              :disabled="(sessionStatus != null ? true : false)"
              v-on="on"
              @click="$emit('removeEvent')"
            >
              <v-icon>mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('remove') }}</span>
        </v-tooltip>
      </div>
    </v-toolbar>
    <v-card-text>
      <v-row v-if="session">
        <v-col
          cols="12"
          md="6"
          class="pa-1"
        >
          <autocomplete
            v-model="teacher"
            title="teacher"
            type="person"
            :new-btn="true"
            :disabled="(sessionStatus || $store.state.accessType ? true : false)"
            :data="JSON.stringify({type: 'teacher'})"
            :value="teacher"
          />
        </v-col>
        <v-col
          v-if="!sessionStatus && !$store.state.accessType"
          cols="12"
          md="6"
          class="pa-1"
        >
          <money
            v-model="teacherCost"
            :label="$t('teacherCost') + '(' + $t('perSession') + ')'"
            :dense="true"
            :outlined="true"
            :solo="false"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
            class="mb-3 dense"
          />
        </v-col>
        <v-col
          v-if="!$store.state.accessType"
          cols="12"
          md="6"
          class="pa-1"
        >
          <v-select
            v-model="sessionStatus"
            :label="$t('status')"
            :items="statusItems"
            height="30"
            dense
            outlined
            :loading="loading"
            item-value="value"
            item-text="text"
            @change="setSessionStatus"
          />
        </v-col>
        <v-col
          v-if="session"
          cols="12"
          class="px-1 mt-4"
        >
          <v-btn
            v-if="!session.event.type"
            color="primary"
            class="ms-0 mt-1"
            outlined
            small
            :disabled="(sessionStatus && $store.state.accessType ? true : false)"
            @click="goAttendance"
          >
            {{ $t('academyStudentAttendance', {name: $store.state.studentLabel}) }}
            <v-icon right>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!$store.state.accessType"
            color="primary"
            class="ms-2 mt-1"
            outlined
            small
            @click="eventStudentList"
          >
            {{ $t('academyEventStudentList', {name: $store.state.studentLabel}) }}
            <v-icon right>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!$store.state.accessType"
            color="primary"
            class="ms-2 mt-1"
            outlined
            small
            @click="studentList"
          >
            {{ $t('addStudentToEvent', {name: $store.state.studentLabel}) }}
            <v-icon right>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!$store.state.accessType && session && !session.event.type"
            color="primary"
            class="ms-2 mt-1"
            outlined
            small
            @click="sessionList"
          >
            {{ $t('academySessionList') }}
            <v-icon right>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            v-if="!session.status && !$store.state.accessType"
            color="green"
            class="ms-2 mt-1"
            outlined
            small
            @click="sendStatusSms('sessionHelding')"
          >
            {{ $t('sendHeldingStatusSms') }}
            <v-icon right>
              mdi-message-processing
            </v-icon>
          </v-btn>
          <v-btn
            v-if="session.status == 'canceled' && !$store.state.accessType"
            color="red"
            class="ms-2 mt-1"
            outlined
            small
            @click="sendStatusSms('sessionCanceld')"
          >
            {{ $t('sendCancelStatusSms') }}
            <v-icon right>
              mdi-message-processing
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          class="px-1"
        >
          <v-chip
            v-if="session"
            class="ma-1 ms-0"
            color="orange"
            label
            small
            text-color="blue-grey darken-4"
          >
            {{ session.jdate }}
          </v-chip>
          <v-chip
            class="ma-1 ms-0"
            color="cyan"
            label
            small
            text-color="white"
          >
            <v-icon left>
              mdi-office-building-outline
            </v-icon>
            {{ $t('place') }} {{ $t('class') }} {{ (selectedEvent.place ? selectedEvent.place.name :'') }}
          </v-chip>
          <v-chip
            v-if="info && session && session.event.type == 'interview'"
            class="ma-1 ms-0"
            color="indigo darken-4"
            label
            small
            text-color="white"
          >
            {{ $t('student', {name: $store.state.studentLabel}) }}: {{ (session.student ? session.student.name : '') }}
          </v-chip>
          <v-chip
            v-if="info && session && !session.event.type"
            class="ma-1 ms-0"
            color="indigo darken-4"
            label
            small
            text-color="white"
          >
            {{ $t('studentCount', {name: $store.state.studentLabel}) }}: {{ info.studentCount }}
          </v-chip>
          <v-chip
            v-if="info && session && !session.event.type"
            class="ma-1 ms-0"
            color="amber"
            label
            small
            text-color="brown"
          >
            {{ $t('sessionTotal') }}: {{ info.total }}
          </v-chip>
          <v-chip
            v-if="info && session && !session.event.type"
            class="ma-1 ms-0"
            color="indigo"
            label
            small
            text-color="white"
          >
            <v-icon left>
              mdi-progress-clock
            </v-icon>
            {{ $t('sessionNotHeld') }}: {{ info.not_held }}
          </v-chip>
          <v-chip
            v-if="info && session && !session.event.type"
            class="ma-1 ms-0"
            color="green"
            label
            small
            text-color="white"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            {{ $t('sessionDone') }}: {{ info.done }}
          </v-chip>
          <v-chip
            v-if="info && session && !session.event.type"
            class="ma-1 ms-0"
            color="pink"
            label
            small
            text-color="white"
          >
            <v-icon left>
              mdi-cancel
            </v-icon>
            {{ $t('sessionCancel') }}: {{ info.canceled }}
          </v-chip>
          <v-chip
            v-if="info && session"
            class="ma-1 ms-0"
            color="purple accent-2"
            label
            small
            text-color="white"
          >
            {{ $t('startTime') }}: {{ session.start_time }}
          </v-chip>
          <v-chip
            v-if="info && session"
            class="ma-1 ms-0"
            color="purple accent-4"
            label
            small
            text-color="white"
          >
            {{ $t('duration') }}: {{ session.duration }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="info && !$store.state.accessType"
        color="primary"
        class="ms-2"
        @click="teacherUpdate"
      >
        {{ $t('submit') }}
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="pink"
        @click="$emit('close')"
      >
        {{ $t('close') }}
      </v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../../Mixins/general'
  export default {
    name: 'AcademySession',
    components: {
    },
    mixins: [General],
    props: ['selectedEvent', 'hideBarBtnProp'],
    data: () => ({
      editName: null,
      teacherCost: null,
      sessionStatus: null,
      statusItems: null,
      teacher: null,
      teacherOld: null,
      render: false,
      isLoading: false,
      status: 'active',
      address: null,
      name: null,
      session: null,
      info: null,
      valid: null,
      message: null,
      id: null,
      loading: false,
    }),
    watch: {
      selectedEvent (val, old) {
        this.changeSelectedEvent(val)
      },
      sessionStatus (val) {
        // this.setSessionStatus()
      },
    },
    beforeMount () {
      this.statusItems = [
        {
          value: null,
          text: this.$t('not-held'),
        },
        {
          value: 'done',
          text: this.$t('done'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
      ]
    },
    mounted () {
      if (this.selectedEvent) {
        this.changeSelectedEvent(this.selectedEvent)
      }
    },
    methods: {
      sessionList () {
        this.$router.push({ name: 'academySessionList', params: { eventProp: this.session.event_id } })
      },
      sendStatusSms (type) {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            sendStatusSms: 'active',
            session: app.session,
            type: type,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      changeSelectedEvent (val) {
        this.session = null
        this.sessionStatus = null
        this.info = null
        this.teacher = val.teacher
        this.teacherOld = val.teacher
        this.teacherCost = val.teacher_cost
        if (val.id) {
          this.getEventInfo(val.id)
        }
      },
      allowedStep: m => m % 5 === 0,
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'academyPlaces', app.$data)
          .then(res => {
            app.goTo('academyPlaceList')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      goAttendance () {
        this.$router.push({ name: 'academyStudentAttendance', params: { sessionProp: this.session } })
      },
      studentList () {
        this.$router.push({ name: 'academyEventStudent', params: { eventProp: this.session.event, sessionProp: (this.session.event.type === 'interview' ? this.session : null) } })
      },
      getEventInfo (id) {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            getEventInfo: 'active',
            sessionId: id,
          },
        })
          .then(res => {
            res = res.data
            app.info = res.info
            app.session = res.session
            app.sessionStatus = res.session.status
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      setSessionStatus () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            setSessionStatus: 'active',
            status: app.sessionStatus,
            session: app.session,
          },
        })
          .then(res => {
            res = res.data
            app.session.status = app.sessionStatus
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('alert-created')
            app.snakbar = true
            app.$emit('updateStatus', app.sessionStatus)
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      teacherUpdate () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            teacherUpdate: 'active',
            teacher: app.teacher,
            teacherCost: app.teacherCost,
            event: app.selectedEvent,
          },
        })
          .then(res => {
            res = res.data
            var data = {
              event: app.selectedEvent,
              teacher: app.teacher,
              teacher_cost: app.teacherCost,
            }
            app.editName = false
            app.$emit('updateTeacher', data)
            app.$emit('close')
          })
          .catch(err => {
            app.teacher = app.teacherOld
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      eventStudentList (item) {
        this.$router.push({ name: 'academyEventStudentList', params: { eventProp: this.session.event } })
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'academyPlaces/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo('academyPlaceList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
  display: none;
  position: absolute;
  left: 50%;
  height: 4px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  width: 16px;
  margin-left: -8px;
  opacity: 0.8;
  content: '';
}

.v-event-drag-bottom:hover::after {
  display: block;
}
.v-event-draggable {
  white-space: normal !important;
  padding: 3px 5px;
  font-size: 11px;
}

</style>
